import React, { useState } from 'react';
// import { Row, Col, Form } from 'react-bootstrap';
// import Select from 'react-select';
import Input from '../inputs';
// import * as BasicForm from '../../elements/forms';
// import TextField from '@mui/material/TextField';
// import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

export const MultiSelect = props => {
  const { columnKey, label, options, setFilter, style, filters } = props;

  const handleInputChange = (selected) => {
    if (selected && selected.length) {
      selected = selected.map((select) => {
        return select.value
      })
      setFilter(columnKey, selected)
    } else {
      setFilter(columnKey, null);
    }
  }

  const formattedOptions = options?.map(value => {
    return value
  })

  const selectedOptions = filters?.[columnKey]?.map(value => (
    formattedOptions.find(option => option.value === value)
  ));

  return (
    <Row style={style}>
      <Col>
        <Autocomplete
          id="user-input"
          multiple
          filterSelectedOptions
          options={formattedOptions?.map(option => {
            return {key: `option${option.label}`, value: option.value, label: option.label}
          })}
          renderInput={(params) =>
            <TextField {...params}
              label={label}
              sx={{marginTop: '20px'}}
            />
          }
          renderOption={(props, option) => (
            <li {...props}>{option.label}</li>
          )}
          getOptionLabel={(option) => {
            return option.label
          }}
          value={selectedOptions || []}
          onChange={(event, newValue) => handleInputChange(newValue)}
        />
      </Col>
    </Row>
  )
}

// export const RestMultiSelect = props => {
//   const { columnKey, label, options, setFilter, style, filters, setTriggerQuery } = props;

//   const handleInputChange = (selected) => {
//     if (selected) {
//       selected = selected.map((select) => {
//         return select.value
//       })
//       setFilter(columnKey, selected)
//       setTriggerQuery(true);
//     }
//   }

//   const setOption = (value) => {
//     switch(value.__typename) {
//       case 'User':
//         return { label: value.email, value: value.id }
//         break;
//       default:
//         return null;
//         break;
//     }
//   }

//   const formattedOptions = options?.map((value) => {
//     return setOption(value)
//   })

//   return (
//     <Row style={style}>
//       <Col>
//         <BasicForm.StyledLabel>{label}</BasicForm.StyledLabel>
//         <Select
//           key={`${columnKey}-select`}
//           options={formattedOptions}
//           isMulti={true}
//           onChange={handleInputChange}
//         />
//       </Col>
//     </Row>
//   )
// }

const FilterSelect = props => {
  const { columnKey, label, options, filters, setFilter, style } = props;

  return (
    <Row style={style}>
      <Col>
        <Form.Label>{label}</Form.Label>
        <Form.Control
          as="select"
          value={filters[columnKey] || 0}
          onChange={event => setFilter(columnKey, event.currentTarget.value)}
        >
          <option key="0" value="">
            Filter by {label}
          </option>
          {
            options &&
              options.map(value => <option key={value}>{value}</option>)
          }
        </Form.Control>
      </Col>
    </Row>
  );
};

// export const RestFilterSelect = props => {
//   const { columnKey, label, options, filters, setFilter, style } = props;

//   return (
//     <Row style={style}>
//       <Col>
//         <Form.Label>{label}</Form.Label>
//         <Form.Control
//           as="select"
//           value={filters[columnKey] || null}
//           onChange={event => setFilter(columnKey, event.currentTarget.value)}
//         >
//           <option key="0" value="">
//             Filter by {label}
//           </option>
//           {
//             options &&
//               options.map(value => <option key={value.id}>{value.name}</option>)
//           }
//         </Form.Control>
//       </Col>
//     </Row>
//   );
// };

// export const FilterSelectObject = props => {
//   const {
//     columnKey,
//     label,
//     options,
//     filters,
//     setFilter,
//     style,
//     labelName
//   } = props;

//   return (
//     <Row style={style}>
//       <Col>
//         <Form.Label>{label}</Form.Label>
//         <Form.Control
//           key={`${columnKey}-select`}
//           as="select"
//           value={filters[columnKey] || null}
//           onChange={event => setFilter(columnKey, event.currentTarget.value)}
//         >
//           <option key="0" value="">
//             Filter by {label}
//           </option>
//           {
//             options &&
//               options.map(
//                 value =>
//                   <option value={value.value} key={value.value}>
//                     {value.label}
//                   </option>
//               )
//           }
//         </Form.Control>
//       </Col>
//     </Row>
//   );
// };

// export const MultiSelectObject = props => {
//   const {
//     columnKey,
//     label,
//     options,
//     setFilter,
//     style,
//     filters,
//     labelName,
//     children,
//     ...otherProps
//   } = props;

//   const handleInputChange = (selected) => {
//     if (selected) {
//       if (false === props.isMulti) {
//         selected = selected.value
//       } else {
//         selected = selected.map((select) => {
//           return select.value
//         });
//       }
//       setFilter(columnKey, selected);
//     } else {
//       setFilter(columnKey, null);
//     }
//   }

//   const formattedOptions = otherProps.formattedOptions || options?.map((value) => {
//     return { label: labelName(value), value: parseInt(value.id)}
//   })

//   let selectedOptions;

//   if (false === props.isMulti) {
//     selectedOptions =
//       formattedOptions.find(option => option.value === filters?.[columnKey]);
//   } else {
//     selectedOptions = filters?.[columnKey]?.map(value => (
//       formattedOptions.find(option => option.value === value)
//     ));
//   }

//   return (
//     <Row style={style}>
//       <Col>
//         <BasicForm.StyledLabel>{label}</BasicForm.StyledLabel>
//         <Select
//           key={`${columnKey}-select`}
//           options={formattedOptions}
//           isMulti={true}
//           onChange={handleInputChange}
//           value={selectedOptions || null}
//           {...otherProps}
//         />
//       </Col>
//       {children}
//     </Row>
//   )
// }

export default FilterSelect;
